module.exports = __webpack_public_path__ + "videos/auto-pilot.a653d2b.mp4";